import { coreMembers, otherMembers } from "../content";
import { SectionHeading } from "./SectionHeading";

function withLineBreaks(text: string) {
  return text.split("\n").map((line, index) => (
    <span key={`${line}-${index}`}>
      {index > 0 && <br />}
      {line}
    </span>
  ));
}

export function Members() {
  return (
    <section
      className="content-section"
      id="members"
      aria-labelledby="members-title"
    >
      <div className="content-width section-layout">
        <SectionHeading index="MEMBERS" title="運営者情報" id="members-title" />
        <div className="section-body">
          <h3 className="member-group-title">共同代表</h3>
          <div className="member-list">
            {coreMembers.map((member) => (
              <article className="member-row" key={member.name}>
                {member.photo && (
                  <img
                    className="member-photo"
                    src={member.photo}
                    alt={member.alt}
                  />
                )}
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-title">{withLineBreaks(member.title)}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="member-other">
            <h3>メンバー</h3>
            <div className="member-name-list">
              {otherMembers.map((member) => (
                <article className="member-other-item" key={member.name}>
                  <p className="member-name">{member.name}</p>
                  <p className="member-title">{withLineBreaks(member.title)}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
